import { ReactNode } from "react";
import { AuthContext, useAuth } from "./customHooks";

export function AuthProvider({ children }: {children: ReactNode}) {
  const auth = useAuth();

  return (<AuthContext.Provider value={auth}>{children}</AuthContext.Provider>);
}